// src/redux/reducers/index.ts

import { combineReducers } from '@reduxjs/toolkit';
import spasReducer from './spas.reducer';
import spaReducer from './spa.reducer';
import userReducer from './user.reducer';
import errorLogReducer from './errorLog.reducer';
import firmwareReducer from './firmware.reducer';
// Import other reducers as needed
import liveReducer from './live.reducer';
import settingsReducer from './settings.reducer';
import logsReducer from './logs.reducer';
import usersReducer from './users.reducer';
import logsRequestReducer from './logsRequest.reducer';
import usersByIdReducer from './usersById.reducer';
import dealershipReducer from './dealership.reducer';
import dealershipsReducer from './dealerships.reducer';
import firmwareUpgradeReducer from './firmwareUpgrade.reducer';
import firmwareUploadReducer from './firmwareUpload.reducer';
import constReducer from './const.reducer';
import errorReducer from './error.reducer';
import statusReducer from './status.reducer';
import upgradeRequestsReducer from './upgradeRequests.reducer';
import spaHistoryReducer from './spaHistory.reducer';
import updateStatusReducer from './updateStatus.reducer';
import commandsReducer from './commands.reducer';
import roleReducer from './role.reducer';
import rolesReducer from './roles.reducer';
import userGroupReducer from './userGroup.reducer';
import userGroupsReducer from './userGroups.reducer.ts';
import permissionReducer from './permission.reducer';
import permissionsReducer from './permissions.reducer';
import roleUsers from './roleUsers.reducer';
import commentsReducer from './comments.reducer';
import commentReducer from './comment.reducer';
import countriesReducer from './countries.reducer';
import regionsReducer from './regions.reducer';
import countryReducer from './country.reducer';
import spaCountReducer from "./spaCount.reducer";
import dashboardReducer from "./dashboard.reducer";
import dealershipUsersReducer from "./dealershipUsers.reducer"
import tubModelsReducer from './tubModels.reducer';
import fieldHistoryReducer from './fieldHistory.reducer';
import fieldHistorySummaryReducer from './fieldHistorySummary.reducer';
import promosReducer from './promos.reducer';
import notificationsReducer from './notifications.reducer';
import myApiKeysReducer from './myApiKeys.reducer';
import manageApiKeysReducer from './manageApiKeys.reducer';
import spaUpdateProgressReducer from './spaUpdateProgress.reducer';
import { UnknownAction } from 'redux';
import { resetAppState } from '../actions/app.actions';

const appReducer = combineReducers({
  spas: spasReducer,
  spa: spaReducer,
  user: userReducer,
  errorLog: errorLogReducer,
  live: liveReducer,
  settings: settingsReducer,
  const: constReducer,
  error: errorReducer,
  status: statusReducer,
  updateStatus: updateStatusReducer,
  logsRequest: logsRequestReducer,
  users: usersReducer,
  logs: logsReducer,
  upgradeRequests: upgradeRequestsReducer,
  usersById: usersByIdReducer,
  dealership: dealershipReducer,
  dealerships: dealershipsReducer,
  dealershipUsers: dealershipUsersReducer,
  firmware: firmwareReducer,
  firmwareUpgrade: firmwareUpgradeReducer,
  firmwareUpload: firmwareUploadReducer,
  spaHistory: spaHistoryReducer,
  commands: commandsReducer,
  role: roleReducer,
  roles: rolesReducer,
  userGroup: userGroupReducer,
  userGroups: userGroupsReducer,
  permission: permissionReducer,
  permissions: permissionsReducer,
  roleUsers: roleUsers,
  comments: commentsReducer,
  comment: commentReducer,
  countries: countriesReducer,
  regions: regionsReducer,
  country: countryReducer,
  spaCount: spaCountReducer,
  dashboard: dashboardReducer,
  tubModels: tubModelsReducer,
  fieldHistory: fieldHistoryReducer,
  fieldHistorySummary: fieldHistorySummaryReducer,
  promos: promosReducer,
  notifications: notificationsReducer,
  myApiKeys: myApiKeysReducer,
  manageApiKeys: manageApiKeysReducer,
  spaUpdateProgress: spaUpdateProgressReducer,
});

const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: UnknownAction) => {
  if (action.type === resetAppState.type) {
    try {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('expirationTime');
      sessionStorage.removeItem('impersonate');
    } catch (_) {}
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;